import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { BasicConfigurationModel } from '@/modules/settings/types/basic';
import { SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'

/**
 * Fetches basic company settings.
 */
export function useSavedBaseSettings(companyId: string) {
  return useQuery<BasicConfigurationModel>({
    queryKey: ['configuration.basic', companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/api/${companyId}/configuration/basic`);
      return data;
    },
    enabled: !!companyId,
    ...SETTINGS_QUERY_NO_CACHE,
  });
}
